import React from "react";

const brands = [
  "PORSCHE",
  "TESLA",
  "BMW",
  "MERCEDES-BENZ",
  "AUDI",
  "FERRARI",
  "LAND ROVER",
  "LEXUS",
  "MASERATI",
];

export default function LogoMarquee() {
  return (
    <section className="bg-[#050505] border-y border-white/5 py-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-6">
        <p className="text-xs uppercase tracking-[0.3em] text-zinc-600 text-center">
          Trusted by enthusiasts who own
        </p>
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="marquee-track flex whitespace-nowrap" style={{ width: "max-content" }}>
          {[...brands, ...brands].map((b, i) => (
            <span
              key={i}
              className="px-12 font-heading text-2xl md:text-3xl tracking-[0.25em] text-zinc-700"
            >
              {b}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
